import React from 'react'
import './newProjects.css'

const NewProjects = () => {

  return (
    <div className="card2">
      <div className="circleRed"></div>
      <div className='newProjects'>
        <div className='newProjectBlock'>New projects coming soon.. 🤠</div>
      </div>
    </div>
  )
}

export default NewProjects